import userService from '../services/userService';

const DEFAULT_INTERVAL_MS = 3000;
const DEFAULT_TIMEOUT_MS = 90_000;

function hasActiveLicense(user) {
  const license = user?.activeLicense;
  if (!license) return false;
  return String(license.is_active ?? 'true') !== 'false';
}

/**
 * Poll GET user until activeLicense appears or timeout.
 */
export async function pollUserLicenseActive(options = {}) {
  const {
    intervalMs = DEFAULT_INTERVAL_MS,
    timeoutMs = DEFAULT_TIMEOUT_MS,
    signal,
    onAttempt,
  } = options;

  const started = Date.now();

  while (Date.now() - started < timeoutMs) {
    if (signal?.aborted) {
      return { ok: false, reason: 'aborted' };
    }

    const result = await userService.getUserInfo();
    if (result?.success && result.data) {
      onAttempt?.(result.data);
      if (hasActiveLicense(result.data)) {
        return { ok: true, user: result.data };
      }
    }

    await new Promise((resolve) => {
      const t = window.setTimeout(resolve, intervalMs);
      if (signal) {
        signal.addEventListener('abort', () => window.clearTimeout(t), { once: true });
      }
    });
  }

  return { ok: false, reason: 'timeout' };
}
